<div id="matchingGame" *ngIf="label">

  <div class="row mx-0 justify-content-center" *ngIf="start">
    <div class="col-12 col-md-auto pt-3">
      <div class="gameTitle gameTitleSm {{lang}}">{{ label[lang].matchingGame }}</div>
    </div>
    <div class="col text-left text-md-right align-self-center mb-3 mb-lg-0">

      <ng-container *ngIf="lang === 'tc'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_tc.png" (click)="gameReset()" />
      </ng-container>
      <ng-container *ngIf="lang === 'sc'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_sc.png" (click)="gameReset()" />
      </ng-container>
      <ng-container *ngIf="lang === 'en'">
        <img class="img-fluid gameReset" src="{{imgpath}}/restart_btn_en.png" (click)="gameReset()" />
      </ng-container>

    </div>
  </div>

  <div class="quizGameWrap {{ lang }}" [ngClass]="{'firstBg': !start}">
    <div [ngClass]="{'mockupBg': start}">

      <div class="row mx-0 justify-content-center" *ngIf="!start">
        <div class="col-12 col-md-11 col-lg-8 mb-3 mb-lg-0">

          <div class="ruleDesc matchingGameDesc">
            <div class="gameTitle {{lang}}">{{ label[lang].matchingGame }}</div>
            <div>
              <label class="{{lang}}">{{ label[lang].gameRule }}</label>
            </div>
            <div>
              {{ label[lang].game2Landing }}<br />
              <br />
            </div>
            <!-- <ul>
              <li>遊戲規則 1 遊戲規則 1 遊戲規則 1</li>
              <li>遊戲規則 2 遊戲規則 2 遊戲規則 2</li>
              <li>遊戲規則 3 遊戲規則 3 遊戲規則 3</li>
            </ul> -->

            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_tc.png" (click)="gameStart()">
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_sc.png" (click)="gameStart()">
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid gameStart mb-4 mb-lg-5" src="{{imgpath}}/start_btn_en.png" (click)="gameStart()">
            </ng-container>

          </div>

        </div>
      </div>

      <div class="row mx-0 justify-content-center" *ngIf="start && !showResult">

        <div class="col-12 col-lg-11 quizGameCore">

          <!-- <div class="gameTitle gameTitleSm">{{ label[lang].pleaseMatch }}</div>
          <div class="dotLine mb-4"></div> -->

          <!-- {{ userSelectedItem | json }} <br /> -->
          <!-- {{ userSelectedItemStatus | json }} <br /> -->
          <!-- {{ userSelectedItemType | json }} -->

          <div class="row">
            <div class="col">

              <div class="matchBlock seed">
                <div class="matchLabel">{{ label[lang].seed }}</div>
                <div class="row mx-0 pl-3 pb-2">
                  <div class="col-6 mb-3 pl-0" *ngFor="let item of seedList">

                    <div class="matchItem" [ngClass]="{
                      'trueAns': (userSelectedItemStatus.seed && userSelectedItem.seed.id === item.id) || checkIsCorrectMatch(item) || (userSelectedItemLock.seed && userSelectedItemLock.seed.id === item.id) , 
                      'wrongAns': userSelectedItemStatus.seed === false && userSelectedItem.seed.id === item.id,
                      'ansMask': ansMask,
                      'done': checkIsCorrectMatch(item)
                    }">

                      <img class="img-fluid" [src]="item.seed" (click)="selectItem(item, 'seed')"
                        [ngClass]="{
                        'selectedAns': userSelectedItem.seed && userSelectedItem.seed.id === item.id, 'pointer': !userSelectedItemLock.seed}">
                      <!-- ({{item.id}}) -->
                    </div>

                  </div>
                </div>
              </div>

            </div>
            <div class="col">

              <div class="matchBlock name">
                <div class="matchLabel">{{ label[lang].fruitName }}</div>
                <div class="row mx-0 pl-3 pb-2">
                  <div class="col-6 mb-3 pl-0" *ngFor="let item of nameList">

                    <div class="matchItem" [ngClass]="{
                      'trueAns': (userSelectedItemStatus.name && userSelectedItem.name.id === item.id) || checkIsCorrectMatch(item) || (userSelectedItemLock.name && userSelectedItemLock.name.id === item.id), 
                      'wrongAns': userSelectedItemStatus.name === false && userSelectedItem.name.id === item.id,
                      'ansMask': ansMask,
                      'done': checkIsCorrectMatch(item)
                    }">

                      <img class="img-fluid" [src]="item.nameTc" (click)="selectItem(item, 'name')"
                        [ngClass]="{
                        'selectedAns': userSelectedItem.name && userSelectedItem.name.id === item.id, 'pointer': !userSelectedItemLock.name}" *ngIf="lang === 'tc'">
                      <img class="img-fluid" [src]="item.nameSc" (click)="selectItem(item, 'name')"
                        [ngClass]="{
                        'selectedAns': userSelectedItem.name && userSelectedItem.name.id === item.id, 'pointer': !userSelectedItemLock.name}" *ngIf="lang === 'sc'">
                      <img class="img-fluid" [src]="item.nameEn" (click)="selectItem(item, 'name')"
                        [ngClass]="{
                        'selectedAns': userSelectedItem.name && userSelectedItem.name.id === item.id, 'pointer': !userSelectedItemLock.name}" *ngIf="lang === 'en'">
                      <!-- ({{item.id}}) -->
                    </div>

                  </div>
                </div>
              </div>

            </div>
            <div class="col">

              <div class="matchBlock photo">
                <div class="matchLabel">{{ label[lang].photo }}</div>
                <div class="row mx-0 pl-3 pb-2">
                  <div class="col-6 mb-3 pl-0" *ngFor="let item of photoList">

                    <div class="matchItem" [ngClass]="{
                      'trueAns': (userSelectedItemStatus.photo && userSelectedItem.photo.id === item.id) || checkIsCorrectMatch(item) || (userSelectedItemLock.photo && userSelectedItemLock.photo.id === item.id), 
                      'wrongAns': userSelectedItemStatus.photo === false && userSelectedItem.photo.id === item.id,
                      'ansMask': ansMask,
                      'done': checkIsCorrectMatch(item)
                    }">

                      <img class="img-fluid" [src]="item.photo" (click)="selectItem(item, 'photo')"
                        [ngClass]="{
                        'selectedAns': userSelectedItem.photo && userSelectedItem.photo.id === item.id, 'pointer': !userSelectedItemLock.photo}">
                      <!-- ({{item.id}}) -->
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="text-center py-3 mb-4 mb-lg-5">

            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid quizSubmit" [ngClass]="{'disable': selectedItemsCorrect.length < seedList.length}"
                src="{{imgpath}}/submit_btn_tc.png" (click)="matchingSubmit()">
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid quizSubmit" [ngClass]="{'disable': selectedItemsCorrect.length < seedList.length}"
                src="{{imgpath}}/submit_btn_sc.png" (click)="matchingSubmit()">
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid quizSubmit" [ngClass]="{'disable': selectedItemsCorrect.length < seedList.length}"
                src="{{imgpath}}/submit_btn_en.png" (click)="matchingSubmit()">
            </ng-container>

          </div>

        </div>

        <div class="col-12 quizGameWrapMockup">
          <img class="img-fluid d-block mx-auto mb-3" src="{{imgpath}}/mobile-mockup.png">
          <div>
            {{ label[lang].pleaseLandscape }}
          </div>
        </div>

      </div>

      <div class="row mx-0 justify-content-center" *ngIf="showResult">
        <div class="col-12 col-md-10 col-lg-8">

          <div class="text-center">

            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_tc.png" />
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_sc.png" />
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid finishBtn" src="{{imgpath}}/finish_title_en.png" />
            </ng-container>

          </div>

          <!-- <div class="row mx-0 mb-4">
            <div class="col-auto align-self-center pr-4 text-right">
              <img class="img-fluid scoreLabel" src="{{imgpath}}/score_tc.png" />
            </div>
            <div class="col">
              <div class="scoreContent">
                <img class="img-fluid" src="{{imgpath}}/award_gold.png" />
                <div class="score">
                  {{ getTrueResultCounter() }} /
                  {{ quizList.length }}
                </div>
              </div>
            </div>
          </div> -->

          <div class="wellDone">
            <img class="img-fluid" src="{{imgpath}}/well_done.png" />
          </div>

          <div>
            <div class="dotLine mb-4"></div>
            <div class="resultContent text-center mb-4">

              {{ label[lang].game2Result }}

              <!-- <table>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
                <tr>
                  <td>Score Summary:</td>
                  <td>a paragraph</td>
                </tr>
              </table> -->

            </div>
            <div class="dotLine mb-3"></div>
          </div>

          <div class="py-4 text-center mb-4 mb-lg-5">

            <ng-container *ngIf="lang === 'tc'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_tc.png" (click)="gameReset()" />
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_sc.png" (click)="gameReset()" />
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <img class="img-fluid gameResetFinish" src="{{imgpath}}/restart_btn_en.png" (click)="gameReset()" />
            </ng-container>

          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="py-3 px-2">
    <!-- <small>{{ label[lang].commonRemark }}</small> -->
    <small>{{ label[lang].seedbankRemark1 }}</small>
    <br />
    <small>{{ label[lang].seedbankRemark2 }}</small>
    <br />
    <small>{{ label[lang].seedbankRemark3 }}</small>
  </div>

</div>